// DataLens 複数物件コード受け渡しの一括取得画面のルート定義。
// container.tsx/presenter.tsx を使わず、本ファイル（routes）に集約する（styleguide 準拠）。
import { Route, Routes } from "react-router-dom";
import React from "react";
import { PropertyCodeBulkAcquisition } from "./PropertyCodeBulkAcquisition";

export const PropertyCodeBulkAcquisitionRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="" element={<PropertyCodeBulkAcquisition />} />
    </Routes>
  );
};
